import { useQuery } from '@tanstack/react-query';
import { notificationsApi } from '../api/notifications.api.js';

/**
 * The one query key every unread badge reads. Exported so the notifications
 * page can invalidate it by the same constant it is registered under, instead
 * of a second hand-written array that has to be kept in step.
 */
export const UNREAD_COUNT_QUERY_KEY = ['notifications', 'unread-count'] as const;

/**
 * Unread notification count for the signed-in user.
 *
 * The desktop bell and the mobile "Alerts" tab are two views of ONE number, so
 * they share this hook rather than each running their own query: same key, same
 * request (React Query dedupes), same refetch cadence. The bar used to carry no
 * badge at all, which meant a phone — the device most of this app's users hold
 * — showed nothing while the desktop header showed a 5.
 */
export function useUnreadNotificationCount(
  options: { enabled?: boolean } = {}
): number {
  const { data } = useQuery({
    queryKey: UNREAD_COUNT_QUERY_KEY,
    queryFn: notificationsApi.unreadCount,
    refetchInterval: 60_000,
    enabled: options.enabled ?? true,
  });
  return data ?? 0;
}
